import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { MaterialModule } from '../material.module';
import { SharedModule } from '../shared/shared.module';
import { PublishDialogComponent } from './components/publish-dialog/publish-dialog.component';
import { ReactiveFormsModule } from '@angular/forms';
import { EmbedSrcDirective } from './directives/embed-src.directive';
import { PublishState } from './state/publish.state';
import { PublishWidgetComponent } from './components/publish-widget/publish-widget.component';
import { PublishComponent } from './components/publish/publish.component';
import { ColorPickerModule } from 'ngx-color-picker';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    SharedModule,
    ColorPickerModule,
    NgxsModule.forFeature([PublishState]),
  ],
  declarations: [
    PublishDialogComponent,
    EmbedSrcDirective,
    PublishWidgetComponent,
    EmbedSrcDirective,
    PublishComponent,
  ],
  exports: [PublishDialogComponent],
  entryComponents: [PublishDialogComponent],
})
export class PublishModule {}
